module.exports = __webpack_public_path__ + "static/media/error-gif.302cdc66.gif";